import { useQuery } from "@tanstack/react-query";
import { SecurityControlCardRequestService } from "../../../../../services/company-office/SecurityControlCardService";
// import { useSelector } from "../../../../../store/store";
import { transformRequestStatus } from "../../../utils";
import {
  getStatusBaseOnApprover,
  getStepBaseOnApprover,
} from "../../../info-technology-process/delete-user-account/utils";
import { useSelector } from "../../../../../store/store";

export const useSecurityControlCardRequests = () => {
  const user = useSelector((state) => state.user);
  const userEmail = user?.current?.username;

  const { data = [], ...restResponse } = useQuery<Array<any>>({
    queryKey: ["security-control-card-requests"],
    queryFn: () => SecurityControlCardRequestService.getSecurityControlCardRequests(userEmail),
  });

  const securityControlCardMyRequests = data.filter(
    (el) => el.createdBy.user.email.toLowerCase() === userEmail.toLowerCase()
  );

  const processedData = data
    .map((record) => {
      const status = getStatusBaseOnApprover(record.fields, userEmail);
      const step = getStepBaseOnApprover(record.fields, userEmail);

      return {
        ...record.fields,
        id: record.id,
        createdByEmail: record.createdBy.user.email,
        createdByName: record.createdBy.user.displayName,
        createdDateTime: record.createdDateTime,
        eRequestStatus: transformRequestStatus(status, { step }),
      };
    })
    .sort((a, b) => b.id - a.id);

  const mappedSecurityControlCardRequests = processedData
    .filter((record) => [record.eAssignee, record.eApprovedByITLead, record.eApprovedByITHead, record.eApprovedBy].some((approver) => approver?.toLowerCase().includes(userEmail.toLowerCase())))

  const mappedSecurityControlCardMyRequests = processedData
    .filter((record) => record.createdByEmail.toLowerCase() === userEmail.toLowerCase())

  const guideLink = "https://drive.google.com/file/d/1xpNL5prqQm4y6r6pUXkcm3clZaCKRel0/view";

  return {
    ...restResponse,
    securityControlCardRequests: data,
    securityControlCardMyRequests,
    mappedSecurityControlCardRequests,
    mappedSecurityControlCardMyRequests,
    guideLink,
  };
};
